import React, { ReactNode } from 'react';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';
import { styled } from '@mui/material';
import {
  NODON_SNACKBAR_COLOR,
  NODON_SNACKBAR_SURFACE,
} from '@client/style/nodon-snackbar.styles';

type NodonSnackbarProviderProps = {
  children: ReactNode;
};

const CONTENT_SIZED_SNACKBAR_STYLE = {
  minWidth: 0,
  width: 'fit-content',
  maxWidth: '100%',
} as const;

/**
 * App-wide snackbars — bottom-center solid white pills.
 */
const NodonSnackbarProvider: React.FC<NodonSnackbarProviderProps> = ({
  children,
}) => {
  return (
    <SnackbarProvider
      hideIconVariant
      disableWindowBlurListener
      maxSnack={1}
      autoHideDuration={3000}
      style={CONTENT_SIZED_SNACKBAR_STYLE}
      SnackbarProps={{
        style: CONTENT_SIZED_SNACKBAR_STYLE,
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      Components={{
        default: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        success: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
      }}
    >
      {children}
    </SnackbarProvider>
  );
};

const StyledMaterialDesignContent = styled(MaterialDesignContent)(
  ({ theme }) => ({
    '&.notistack-MuiContent-default': {
      ...NODON_SNACKBAR_SURFACE,
      color: NODON_SNACKBAR_COLOR.default,
    },
    '&.notistack-MuiContent-info': {
      ...NODON_SNACKBAR_SURFACE,
      color: NODON_SNACKBAR_COLOR.info,
    },
    '&.notistack-MuiContent-error': {
      ...NODON_SNACKBAR_SURFACE,
      color: NODON_SNACKBAR_COLOR.error,
    },
    '&.notistack-MuiContent-warning': {
      ...NODON_SNACKBAR_SURFACE,
      color: NODON_SNACKBAR_COLOR.warning,
    },
    '&.notistack-MuiContent-success': {
      ...NODON_SNACKBAR_SURFACE,
      color: theme.palette.text.primary,
    },
  }),
);

export default NodonSnackbarProvider;
